/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".tileImage_d2602eab{display:block}"}]);
export const tileImage = "tileImage_d2602eab";